<template>
  <!-- pages/address_book/address_book.wxml -->
  <div class="add_book">
    <Header title="我的地址簿"></Header>

    <!-- 已填地址列表 -->
    <div v-if="addressList.length">
      <div
        class="common-wrap flex add_book_item"
        v-for="(item, index) in addressList"
        :key="index"
      >
        <div class="add_book_detail" @click="select_address(item)">
          <div class="detail_title">{{ item.name }}</div>
          <div class="detail_phone">{{ item.phone }}</div>
          <div class="detail_add">
            {{ item.province }}{{ item.city }}{{ item.area
            }}{{ item.detail_address }}
          </div>
          <div class="flex detail_default" @click="select_is_default(item, index)">
            <img
              v-if="item.is_default"
              src="https://oss01.dayou.art/add_selected.png"
            />
            <img
              v-if="!item.is_default"
              src="https://oss01.dayou.art/add_noselect.png"
            />
            <span>默认地址</span>
          </div>
        </div>

        <div class="flex add_book_button">
          <div class="bottun_edit">
            <img
              src="https://oss01.dayou.art/add_edit.png"
              @click="edit_link(item)"
            />
          </div>
          <span class="button_del" @click="del(item)">删除</span>
        </div>
      </div>
    </div>
    <div v-else class="no-address">
      <img
        class="no-address-img"
        src="https://oss01.dayou.art/tresor-address-nodata.png"
        mode="widthFix"
      />
      <div class="no-address-font">暂无地址，快来添加吧～</div>
    </div>

    <myDialog
      :info="my_dialog"
      @colse="colse"
      @delete="delete_address"
    ></myDialog>

    <div class="common-button edit_button flex" @click="add_link">
      添加收货人地址
    </div>
  </div>
</template>

<script>
import { updata_address, address_list, delete_address } from "@/api/quanyi.js";
import myDialog from "@/components/dialog/my_dialog/my_dialog";
// pages/address_book/address_book.js
export default {
  components: {
    myDialog,
  },
  data() {
    return {
      select_flag: true,
      addressList: [],
      step: 0,
      address_id: 0,
      address_index: 0,
      router_status: true, //是否回到上一页
      option: {},

      my_dialog: {
        dialogShow: false,
        title: "确定删除地址？",
        contents: [
          {
            text: "删除地址后将不能还原",
            class: "reason  ",
          },
        ],
        buttons: [
          {
            text: "取消",
            class: `btn_ok `,
            funcName: "colse",
          },
          {
            text: "确认",
            class: ` btn_ok btn_vip btn_vip_color `,
            funcName: "delete",
          },
        ],
      },
    };
  },
  /**
   * 生命周期函数--监听页面加载
   */
  created() {
    const query = this.$route.query;
    this.step = query.step;
    this.option = query;
    this.getAddressList();
    localStorage.removeItem("addressInfo");
  },
  methods: {
    init() {
      this.getAddressList();
    },
    add_link() {
      const { type } = this.option;
      // uni.navigateTo({
      //     url: `../address_detail/address_detail?type=0&step=${this.step}&route_type=${type || 0}`
      // });
      this.$router.push({
        name: "addressDetail",
        query: {
          type: 0,
          step: this.step,
          route_type: type || 0,
        },
      });
    },

    edit_link(item) {
      this.not_router();
      localStorage.setItem("addressInfo", JSON.stringify(item));
      const { type } = this.option;
      // uni.navigateTo({
      //     url: `../address_detail/address_detail?type=1&step=${this.step}&route_type=${type || 0}`
      // });
      this.$router.push({
        name: "addressDetail",
        query: {
          type: 1,
          step: this.step,
          route_type: type || 0,
        },
      });
    },

    // 获取收获地址列表
    getAddressList() {
      address_list({}).then((data) => {
        this.addressList = data.list;
        this.address_index = data.list.findIndex((item) => item.is_default);
      });
    },

    //删除地址
    delete_address() {
      delete_address({
        id: this.address_id,
      }).then(() => {
        this.my_dialog.dialogShow = false;
        this.getAddressList();
      });
    },

    // 拦截跳转
    not_router() {
      setTimeout(() => {
        this.router_status = false;
      }, 20);
    },

    //删除弹窗
    del(item) {
  //    console.log(item);
      this.not_router();
      this.my_dialog.dialogShow = true;
      this.address_id = item.id;
    },

    colse() {
      //退出
      this.my_dialog.dialogShow = false;
    },

    // 设置默认地址
    select_is_default(form, index) {
      this.not_router();
      const { address_index } = this;
      const isis_default = form.is_default === 1; // 判断当前点击项是否是默认项

      if (isis_default) return;
      if (this.select_flag) {
        this.select_flag = false;
      } else {
        return;
      }

      form.is_default = +!form.is_default;
      form.detailed = form.detail_address;

      updata_address({ ...form }).then(() => {
    //    console.log(res);
        // 选中项不是默认地址时，设置选中项为默认地址
        // debugger
        if (index !== address_index) this.addressList[index].is_default = 1;

    //    console.log(this.addressList[index].is_default, "789");
        if (address_index !== -1) {
          this.addressList[address_index].is_default =
            +!this.addressList[address_index].is_default;
        }
    //    console.log(this.addressList[index].is_default, "567");
        this.address_index = form.is_default ? index : -1;
        this.select_flag = true;
      });
    },

    //选择地址
    select_address(item) {
      this.router_status = true;
      //判断是否从其他路径选择地址
      if (this.option.type != 1) return false;
      setTimeout(() => {
        if (!this.router_status) return false;
    //    console.log(item);
        localStorage.setItem("currentAddress", JSON.stringify(item));
        this.$router.go(-1);
      }, 100);
    },
  },
};
</script>

<style lang="less" scoped>
@import "./address_book.less";
</style>
